import ListingPage from "../components/ListingPage";
import { SYMPTOMS } from "../data/site";

export default function SymptomsIndex() {
  const items = SYMPTOMS.map((s) => ({
    slug: s.slug,
    shortTitle: s.title,
    blurb: s.blurb,
  }));
  return (
    <ListingPage
      kind="Symptom"
      slug="symptoms"
      eyebrow="Symptoms · Varanasi"
      title="Find the right specialist by symptom."
      subtitle="Most people come to us with a symptom — not a diagnosis. Pick the closest match and read the doctor-written guide for what it usually means and how it is treated."
      items={items}
      seoTitle="Gastro & Liver Symptoms — Specialist in Varanasi | Dr. Indresh Dixit"
      seoDescription="Doctor-written guides for common gastro and liver symptoms — acidity, gas, constipation, blood in stool, abdominal pain, jaundice, bloating, IBS — and how Dr. Indresh Dixit treats them in Varanasi."
    />
  );
}
